// Central contact & integration constants
export const WHATSAPP_NUMBER = "+48606247441";
export const WHATSAPP_DISPLAY = "+48 606 247 441";
export const CONTACT_EMAIL = "seham@marhaba.pl";
export const STRIPE_CONSULTATION_URL =
  "https://buy.stripe.com/28EfZh1E98pB6dD07me7m13";
export const MARHABA_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_legalize-poland-easy/artifacts/fb7opjqs_Original.svg";

export const buildWhatsAppLink = (message = "") => {
  const base = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

export const DEFAULT_WA_MESSAGE =
  "مرحباً، أرغب بمعرفة المزيد عن خدمات iqama.pl لتقنين الإقامة في بولندا.";
export const CONSULTATION_WA_MESSAGE =
  "مرحباً، أرغب بحجز استشارة (100€) بخصوص تقنين إقامتي في بولندا.";
export const FULL_SUPPORT_WA_MESSAGE =
  "مرحباً، أرغب بطلب الدعم الكامل (500€) لتقنين إقامتي في بولندا.";
